import { Navigate } from "react-router";
import { useGetRolePermissionQuery } from "../../../apis/RolePermission.api";
import { PrimaryRolePermission, RolePermission } from "../../../types/models/RolePermission";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const RolePermissionScoped = () => {
    const {
        data,
    } = useGetRolePermissionQuery(PrimaryRolePermission.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/role-permissions/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default RolePermissionScoped;
